export function buildPartialDeleteError({ items }) {
  const details = items.map((err) => `${err.id}: ${err.message}`).join("\n");
  return new Error(`Failed to delete ${items.length} selected calendars.\n${details}`);
}
